
import { supabase } from "@/integrations/supabase/client";
import { BaseApiClient } from "../../baseApiClient";
import { logger } from "@/lib/logger";
import { BusinessData } from "../types";
import { businessMapper } from "../mappers";

/**
 * Fetches a business by its owner ID
 */
export async function fetchBusinessByOwnerId(ownerId: string): Promise<BusinessData | null> {
  return BaseApiClient.request<BusinessData | null>(
    `business:owner:${ownerId}`,
    async () => {
      try {
        const { data, error } = await supabase
          .from('business')
          .select('*')
          .eq('owner_id', ownerId)
          .maybeSingle();
        
        if (error) {
          throw new Error(`Failed to fetch business: ${error.message}`);
        }
        
        // If no data found, return null
        if (!data) return null;
        
        // Convert database record to frontend format
        return businessMapper.toFrontend(data);
      } catch (error) {
        logger.error({
          message: "Error fetching business by owner",
          error: error instanceof Error ? error : new Error(String(error)),
          context: { ownerId }
        });
        throw error;
      }
    }
  );
}
